import { base64ToArrayBuffer } from './base64ToArrayBuffer'
import { isBlob } from './isBlob'

export function download(data: Blob | string, fileName: string, type?: string): void {
  if (!data) {
    console.warn('No data to download.')
    return
  }

  // TS2315: Type 'Uint8Array' is not generic.
  // @ts-ignore
  let buffer: Blob | Uint8Array<ArrayBuffer>

  if (isBlob(data)) {
    buffer = data
  } else {
    buffer = base64ToArrayBuffer(data)
  }

  const a = document.createElement('a')
  const blob = new Blob([buffer], { type })
  const blobURL = window.URL.createObjectURL(blob)

  a.href = blobURL
  a.setAttribute('download', fileName)
  document.body.appendChild(a)
  a.click()

  a.remove()
  window.URL.revokeObjectURL(blobURL)
}
